"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 *	Opens a connexion.
 *	Needs Autobahn to be loaded first, as we are using the "ab" global.
 *
 *	@param {string} url - Socket URL.
 *	@return {Promise} - Promise on the connection success.
 */
var open = exports.open = function open(url) {
  return new Promise(function (resolve, reject) {
    return ab.connect(url, resolve, reject);
  } // eslint-disable-line no-undef
  );
};